import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, FormTextarea, SectionHeader } from '../form';

const GeneralInformation: React.FC<any> = ({ formik }) => {
  const { t } = useTranslation();

  return (
    <SectionHeader
      title={t('prechecks.generalInfo')}
      icon={
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      }
      iconBgColor="bg-blue-100"
      iconTextColor="text-blue-600"
      titleColor="text-blue-600"
    >
      <FormField
        id="genComp"
        name="genComp"
        label={t('prechecks.merchantCompanyName')}
        type="text"
        value={formik.values.genComp}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genComp}
        touched={formik.touched.genComp}
        required
      />

      <FormField
        id="genAddr"
        name="genAddr"
        label={t('prechecks.fullMerchantAddress')}
        type="text"
        value={formik.values.genAddr}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genAddr}
        touched={formik.touched.genAddr}
        required
      />

      <FormField
        id="genDirName"
        name="genDirName"
        label={t('prechecks.nameOfDirector')}
        type="text"
        value={formik.values.genDirName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genDirName}
        touched={formik.touched.genDirName}
        required
      />

      <FormField
        id="genDirEmail"
        name="genDirEmail"
        label={t('prechecks.directorEmailAddress')}
        type="email"
        value={formik.values.genDirEmail}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genDirEmail}
        touched={formik.touched.genDirEmail}
        required
      />

      <FormField
        id="genDirAddr"
        name="genDirAddr"
        label={t('prechecks.privateAddressDirector')}
        type="text"
        value={formik.values.genDirAddr}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genDirAddr}
        touched={formik.touched.genDirAddr}
        required
      />

      <FormField
        id="genTaxID"
        name="genTaxID"
        label={t('merchant.federalTaxID')}
        type="text"
        value={formik.values.genTaxID}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genTaxID}
        touched={formik.touched.genTaxID}
        required
      />

      <FormTextarea
        id="genDesc"
        name="genDesc"
        label={t('prechecks.detailedDescription')}
        value={formik.values.genDesc}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genDesc}
        touched={formik.touched.genDesc}
        required
        rows={4}
      />

      <FormTextarea
        id="genPrice"
        name="genPrice"
        label={t('prechecks.describePricing')}
        value={formik.values.genPrice}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genPrice}
        touched={formik.touched.genPrice}
        required
        rows={4}
      />

      <FormTextarea
        id="genUrl"
        name="genUrl"
        label={t('prechecks.urlsUsed')}
        value={formik.values.genUrl}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genUrl}
        touched={formik.touched.genUrl}
        required
        rows={4}
      />

      <div className="border-t border-slate-200 my-8"></div>
      <h4 className="text-xl font-semibold mb-4 text-slate-800 flex items-center gap-2">
        <svg className="w-5 h-5 text-slate-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        {t('prechecks.contactInformation')}
      </h4>

      <FormField
        id="genFullName"
        name="genFullName"
        label={t('merchant.fullName')}
        type="text"
        value={formik.values.genFullName}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genFullName}
        touched={formik.touched.genFullName}
        required
      />

      <FormField
        id="genEmail"
        name="genEmail"
        label={t('prechecks.emailAddress')}
        type="email"
        value={formik.values.genEmail}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genEmail}
        touched={formik.touched.genEmail}
        required
      />

      <FormField
        id="genSkype"
        name="genSkype"
        label={t('merchant.skype')}
        type="text"
        value={formik.values.genSkype}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genSkype}
        touched={formik.touched.genSkype}
      />

      <FormField
        id="genPhone"
        name="genPhone"
        label={t('merchant.phone')}
        type="tel"
        value={formik.values.genPhone}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.errors.genPhone}
        touched={formik.touched.genPhone}
      />

      <FormField
        id="genRefSource"
        name="genRefSource"
        label={t('prechecks.howDidYouHear')}
        type="text"
        value={formik.values.genRefSource}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
      />
    </SectionHeader>
  );
};

export default GeneralInformation;
